<template>
    <div>
        <div v-if="state === 'loading'">
            <Loader></Loader>
        </div>
        <div v-else>
            <custom-contract-sign-header
                :extra="hasExtraTenantStep"
                :step="step"
                :custom-contract="customContract"
            />
            <div v-if="step === 'sign' || step === 'extra-sign'" class="signing-content">
                <div class="content-box small">
                    <div>
                        <h2>{{ $t('review-sign.sign.headline') }}</h2>

                        <div v-if="method === 'unknown'" class="choose-signing-type">
                            <div class="choose-btn nemid" @click="method='nemid'">
                                <div>
                                    <div class="icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="222.485" height="50"
                                             viewBox="0 0 444.97 100">
                                            <path fill="#1c073e"
                                                  d="M2031.05,1011.37a3.541,3.541,0,1,0,7.07,0V919.733a3.541,3.541,0,1,0-7.07,0v91.637Zm61.86-4.04h-19.16c-2.72,0-3.54-1.12-3.54-4.19v-75.3c0-3.07.82-4.179,3.54-4.179h18.22c28.94,0,42.67,17.433,42.67,41.827,0,25.1-15.22,41.843-41.73,41.843m0.42-90.651h-21.75c-5.71,0-8.45,3.059-8.45,9.332v78.949c0,6.27,2.74,9.34,8.45,9.34h20.53c31.11,0,49.89-20.353,49.89-49.521,0-29.271-18.36-48.1-48.67-48.1m-389.52,11.157c0-2.516.69-3.07,1.63-3.07,0.96,0,1.77,1.54,2.18,2.084l52.61,81.86c1.24,1.82,3.28,4.88,8.03,4.88,5.18,0,7.89-3.75,7.89-9.48V919.879c0-2.515-1.63-3.768-3.39-3.768-1.78,0-3.4,1.253-3.4,3.768v83.261c0,2.53-.69,3.07-1.64,3.07s-1.76-1.53-2.17-2.1l-52.61-81.86c-1.23-1.817-3.28-4.886-8.04-4.886-5.17,0-7.88,3.757-7.88,9.486v84.53a3.411,3.411,0,1,0,6.79,0V927.836Zm171.03,83.534a3.41,3.41,0,0,0,3.41,3.75c1.77,0,3.39-1.24,3.39-3.75V927.135c0-2.515.55-3.069,1.5-3.069s1.91,1.54,2.32,2.094l29.37,42.412a3.366,3.366,0,0,0,2.97,1.8,3.41,3.41,0,0,0,3-1.8l29.65-42.412c0.39-.554,1.34-2.094,2.3-2.094,0.94,0,1.48.554,1.48,3.069v84.235a3.4,3.4,0,0,0,3.42,3.75c1.76,0,3.38-1.24,3.38-3.75V925.893c0-5.729-2.57-9.219-7.74-9.219-4.75,0-6.66,2.772-8.17,4.866l-27.18,39.784-27.19-39.784c-1.36-1.94-3.27-4.866-8-4.866-5.18,0-7.91,3.767-7.91,9.486v85.21Zm-43.78-48.415a3.478,3.478,0,0,0,4.86.031c1.43-1.437,1-3.686-.34-5.092l-26.79-29.23c-1.5-1.653-2.05-2.361-2.05-3.347s0.68-1.663,2.17-1.663h41.61c2.45-.144,3.69-1.694,3.69-3.491a3.4,3.4,0,0,0-3.69-3.48h-43.51c-4.76,0-8.03,2.5-8.03,6.827,0,4.045,2.86,7.249,5.31,9.9Zm27.5,37.785a3.623,3.623,0,0,0-.95-5.111,3.364,3.364,0,0,0-4.85,1.232c-1.59,2.1-8.55,12.139-24.11,12.139-12.22,0-25.55-7.42-25.55-23.3,0-13.983,13.29-20.092,15.7-21.221,2.28-1.109,2.68-3.132,1.82-4.784-0.82-1.6-2.5-2.464-4.8-1.448-3.58,1.252-19.83,8.86-19.83,27.741,0,18.541,14.55,30,31.84,30,15.83,0,26.45-7.7,30.73-15.25"
                                                  transform="translate(-1697.03 -916)"/>
                                        </svg>
                                    </div>
                                    <span>{{ $t('review-sign.sign.nemid') }}</span>
                                </div>
                            </div>
                            <div class="choose-btn" @click="method = 'graphic'">
                                <span>{{ $t('review-sign.sign.esignature') }}</span>
                            </div>
                        </div>

                        <div v-if="method === 'graphic'">
                            <graphic-signature
                                ref="signatureComponent"
                                :state="state"
                                v-on:success="sign('graphic', $event);"
                            />
                        </div>

                        <div v-if="method === 'nemid'" class="nemid-container">
                            <custom-contract-nemid-signature
                                ref="signatureComponent"
                                :state="state"
                                v-on:success="sign('nemid', $event);"
                            />
                        </div>

                        <div v-if="method !== 'unknown' && state !== 'saving'">
                            <div class="back-container" @click="method = 'unknown'">
                                <div class="icon">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="5.895" height="9.895"
                                         viewBox="0 0 11.79 19.79">
                                        <path class="fill-purple"
                                              d="M3256.31,2083.51l-6.48,6.49,6.48,6.49a1.994,1.994,0,0,1-2.82,2.82l-7.8-7.8a2.256,2.256,0,0,1,0-3.02l7.8-7.8A1.994,1.994,0,0,1,3256.31,2083.51Z"
                                              transform="translate(-3245.12 -2080.12)"/>
                                    </svg>
                                </div>
                                <p>{{ $t('review-sign.sign.select-method') }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="step === 'success-first-sign'" class="signing-content success">
                <div class="content-box small">
                    <div class="container">
                        <div class="icon">
                            <simple-svg
                                :filepath="'images/SVG/Success.svg'"
                                :height="'175px'"
                                :width="'175px'"
                            />
                        </div>
                        <h1>Kontrakten er nu underskrevet af dig og nu skal den næste lejer også underskrive</h1>
                        <button class="purple" @click="handleExtraSignature()">Næste underskrift</button>
                    </div>
                </div>
            </div>

            <div v-if="step === 'success'" class="signing-content success">
                <div class="content-box small">
                    <div class="container">
                        <div class="icon">
                            <simple-svg
                                :filepath="'images/SVG/Success.svg'"
                                :height="'175px'"
                                :width="'175px'"
                            />
                        </div>
                        <h1>{{ $t('contract-signed.headline.label') }}</h1>
                        <p class="text">{{ $t('contract-signed.text.label') }}</p>
                        <router-link :to="{name: 'contracts'}">
                            <button class="purple">{{ $t('contract-signed.go-to-overview.button') }}</button>
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CustomContractSignHeader from "./CustomContractSignHeader";
import SignatureField from "../../signing/parts/SignatureField";
import GraphicSignature from "./GraphicSignature";
import CustomContractNemidSignature from "./CustomContractNemidSignature";
import Loader from "../../../components/Loader";

import customContractMixin, {
    ROLE_LANDLORD,
    ROLE_TENANT,
    SIGNED_BY_LANDLORD,
    SIGNED_BY_TENANT
} from '../../../mixins/custom-contract';

export default {
    name: "CustomContractSign",
    mixins: [customContractMixin],
    components: {
        CustomContractNemidSignature,
        GraphicSignature,
        CustomContractSignHeader,
        SignatureField,
        Loader
    },
    data: function () {
        return {
            method: 'unknown',
            step: 'sign',
            nemidEndpoint: window.config.nemid_endpoint,
            customContract: {},
            state: 'ready'
        };
    },
    methods: {
        sign(method, value) {
            this.state = 'saving';

            axios({
                method: 'PUT',
                url: window.config.apiUrl + `api/custom-contract/${this.customContract.id}/sign`,
                cancelToken: window.AuthorizationCancelSource.token,
                data: {
                    method: method,
                    value: value
                }
            }).then(response => {
                this.state = 'ready';
                this.customContract = response.data.data;

                if (this.hasExtraTenantStep && !this.customContract.is_signed_by_extra_tenant) {
                    if (this.$refs.signatureComponent !== undefined) {
                        this.$refs.signatureComponent.clear();
                    }

                    this.step = 'success-first-sign';
                    this.method = 'unknown';
                } else {
                    this.step = 'success';
                }
            }).finally((e) => {
                this.state = 'ready';
            });
        },
        handleExtraSignature() {
            this.step = 'extra-sign';
            this.method = 'unknown';
        }
    },
    computed: {
        frameUrl() {
            return this.nemid_endpoint + '/launcher/std/' + this.now
        },
        hasExtraTenantStep() {
            let status = this.getContractStatusSet(this.customContract);
            return status.includes(ROLE_TENANT) && this.customContract.has_extra_tenant_signature;
        }
    },
    mounted() {
        this.state = 'loading';

        axios({
            method: 'GET',
            url: window.config.apiUrl + `api/custom-contract/${this.$route.params.id}`
        }).then((response) => {
            this.customContract = response.data.data;

            let status = this.getContractStatusSet(this.customContract);

            if ((status.includes(SIGNED_BY_TENANT) && status.includes(SIGNED_BY_LANDLORD))
                || (status.includes(ROLE_TENANT) && status.includes(SIGNED_BY_TENANT))
                || (status.includes(ROLE_LANDLORD) && status.includes(SIGNED_BY_LANDLORD))
            ) {
                this.$router.push({
                    name: 'custom-contract::view',
                    params: {
                        id: this.$route.params.id
                    }
                })
            } else {
                if (_.filter(this.customContract.tenants, {'is_signed': true}).length === this.customContract.tenants.length
                    && this.hasExtraTenantStep
                    && !this.customContract.is_signed_by_extra_tenant) {
                    this.step = 'extra-sign';
                }
                this.state = 'ready'
            }

        }).finally((e) => {
            this.state = 'ready'
        });
    }
}
</script>

<style scoped>

</style>
